import { useId } from 'react';

/**
 * displaycms brand mark + wordmark, sized for the sidebar header.
 *
 * The mark (signage screen + play + broadcast arcs) is transparent-backed so it
 * sits cleanly on the dark sidebar. The wordmark uses `currentColor` for
 * "display" (so it inherits the sidebar foreground and works on light OR dark
 * surfaces) and the sky accent for "cms". When `collapsed`, only the mark shows.
 */
export function Logo({ collapsed = false }: { collapsed?: boolean }) {
  const gid = useId();
  return (
    <span className="flex items-center gap-2.5" aria-label="displaycms">
      <svg
        width="30"
        height="30"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <defs>
          <linearGradient id={gid} x1="6" y1="9" x2="34" y2="31" gradientUnits="userSpaceOnUse">
            <stop stopColor="#38bdf8" />
            <stop offset="1" stopColor="#6366f1" />
          </linearGradient>
        </defs>
        {/* broadcast arcs */}
        <g stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.9">
          <path d="M9 11 a13 13 0 0 1 22 0" />
          <path d="M13.5 7.5 a8.5 8.5 0 0 1 13 0" />
        </g>
        {/* screen */}
        <rect x="5" y="12" width="30" height="19" rx="4.5" fill={`url(#${gid})`} />
        {/* play glyph */}
        <path d="M17 18 L26 21.5 L17 25 Z" fill="#0f172a" />
        {/* stand */}
        <rect x="18" y="31" width="4" height="4" fill="#38bdf8" />
        <rect x="13" y="35" width="14" height="3" rx="1.5" fill="#38bdf8" />
      </svg>
      {!collapsed && (
        <span className="text-lg font-bold tracking-tight leading-none">
          display<span className="text-sky-400">cms</span>
        </span>
      )}
    </span>
  );
}
